export default __webpack_public_path__ + "static/media/uploadEn3.e4313bca.jpg";